<template>
    <v-form>
        <v-card>
            <v-toolbar dark color="primary">
                <v-toolbar-title>Add Configuration</v-toolbar-title>
                <slot name="header"></slot>
            </v-toolbar>
            <v-card-text>
                <v-container grid-list-md>
                    <v-layout wrap>
                        <v-flex xs12>
                            <v-select
                                label="Type"
                                :items="configurationTypes"
                                v-model="selectedConfigurationType"
                                v-validate="'required'"
                                :error-messages="errors.first('type')"
                                name="type"
                                required
                            ></v-select>
                        </v-flex>
                        <v-flex xs12>
                            <v-select
                                label="Configuration"
                                item-value="id"
                                item-text="name"
                                :items="filteredConfigurations"
                                v-model="selectedConfigurationId"
                                v-validate="'required'"
                                :error-messages="errors.collect('configurations')"
                                name="configurations"
                                required
                            ></v-select>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
            <v-card-actions>
               <v-spacer></v-spacer>
               <slot name="actions"></slot>
               <v-btn
                 color="primary"
                 :disabled="disableSubmit || this.submitted"
                 @click="submit"
               >Save Changes
               </v-btn>
            </v-card-actions>
        </v-card>
    </v-form>
</template>
<script>
  import FormValidation from '../FormValidation.vue';

  export default {
    props: {
      configurations: {
        required: true
      },
      configurationTypes: {
        required: true
      },
    },
    mixins: [FormValidation],
    methods: {
      submitForm() {
        this.submitted = true;
        this.add();
      },
      add() {
        this.$emit('add', {configurationId: this.selectedConfigurationId});
        this.submitted = false;
        this.selectedConfigurationId = null;
        this.selectedConfigurationType = null;
      },
      cancel() {
        this.$emit('cancel');
      }
    },
    data() {
      return {
        id: '',
        submitted: false,
        selectedConfigurationType: null,
        selectedConfigurationId: null,
      };
    },
    computed: {
      filteredConfigurations() {
        if (!this.selectedConfigurationType) { return []; }
        return this.configurations.filter(c => c.type === this.selectedConfigurationType);
      },
    },
    watch: {
      value(val) {
        if (val.id) {
          this.id = val.id;
        } else {
          this.id = this.$uuid.v1();
        }
        this.submitted = false;
      },
    }
  };
</script>
